/*
 * Tema warna admin MYPRO. Setiap tema mengisi CSS variable di :root,
 * yang dipakai semua komponen (var(--mp-brand), var(--mp-accent), dst.).
 * Pilihan tersimpan di localStorage dan dipasang sebelum React dirender.
 */

const hexToRgb = (hex) => {
  const h = hex.replace('#', '');
  const n = parseInt(h, 16);
  return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

// brand = warna utama paling gelap, brand2 = tengah gradasi, accent = warna cerah,
// ink = teks gelap, gold/warm = sorot hangat, cool = sorot dingin, topbar = latar bar atas
const RAW = [
  {
    id: 'royal', name: 'Royal MYPRO', desc: 'Biru brand asli',
    brand: '#010080', brand2: '#1E1EB0', accent: '#3D3DE8', ink: '#0A0A4A',
    gold: '#FFC94D', warm: '#F97316', cool: '#22D3EE', topbar: '#303A75'
  },
  {
    id: 'emerald', name: 'Emerald', desc: 'Hijau segar',
    brand: '#044B3A', brand2: '#047857', accent: '#10B981', ink: '#022C22',
    gold: '#FDE68A', warm: '#F59E0B', cool: '#22D3EE', topbar: '#0F5C48'
  },
  {
    id: 'sunset', name: 'Sunset', desc: 'Merah jingga hangat',
    brand: '#7F1D1D', brand2: '#B91C1C', accent: '#F43F5E', ink: '#3F0D12',
    gold: '#FDE047', warm: '#FB923C', cool: '#FBBF24', topbar: '#8F2A2A'
  },
  {
    id: 'ocean', name: 'Ocean', desc: 'Biru laut & tosca',
    brand: '#0C4A6E', brand2: '#0369A1', accent: '#0EA5E9', ink: '#082F49',
    gold: '#FFD166', warm: '#FB7185', cool: '#2DD4BF', topbar: '#1B5C82'
  },
  {
    id: 'violet', name: 'Violet', desc: 'Ungu elegan',
    brand: '#3B0764', brand2: '#6D28D9', accent: '#A855F7', ink: '#1E0A3C',
    gold: '#FDE047', warm: '#F472B6', cool: '#22D3EE', topbar: '#4C1D8A'
  }
];

export const MPRO_THEMES = RAW.map((t) => ({
  ...t,
  brandRgb: hexToRgb(t.brand),
  accentRgb: hexToRgb(t.accent),
  inkRgb: hexToRgb(t.ink),
  warmRgb: hexToRgb(t.warm),
  coolRgb: hexToRgb(t.cool)
}));

export const DEFAULT_THEME_ID = 'royal';
const STORAGE_KEY = 'mp-admin-theme';

export const getSavedThemeId = () => {
  try {
    const id = window.localStorage.getItem(STORAGE_KEY);
    return MPRO_THEMES.some((t) => t.id === id) ? id : DEFAULT_THEME_ID;
  } catch (e) {
    return DEFAULT_THEME_ID;
  }
};

export const applyMproTheme = (id, { persist = true } = {}) => {
  const t = MPRO_THEMES.find((x) => x.id === id) || MPRO_THEMES[0];
  const root = document.documentElement;
  const vars = {
    '--mp-brand': t.brand,
    '--mp-brand-2': t.brand2,
    '--mp-accent': t.accent,
    '--mp-ink': t.ink,
    '--mp-gold': t.gold,
    '--mp-warm': t.warm,
    '--mp-cool': t.cool,
    '--mp-topbar': t.topbar,
    '--mp-brand-rgb': t.brandRgb,
    '--mp-accent-rgb': t.accentRgb,
    '--mp-ink-rgb': t.inkRgb,
    '--mp-warm-rgb': t.warmRgb,
    '--mp-cool-rgb': t.coolRgb
  };
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
  root.setAttribute('data-mp-theme', t.id);
  if (persist) {
    try {
      window.localStorage.setItem(STORAGE_KEY, t.id);
    } catch (e) {
      /* abaikan: penyimpanan tidak tersedia */
    }
  }
  return t;
};
